// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4Itrk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _loginContainer = require("../Components/Login/LoginContainer");
var _loginContainerDefault = parcelHelpers.interopDefault(_loginContainer);
exports.default = /*#__PURE__*/ (0, _react.memo)(Login);
function Login(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginContainerDefault.default), {
        ...props
    });
}
Login.propTypes = {
    handleLoginSuccess: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","../Components/Login/LoginContainer":"2UG5s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UG5s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoginContainer", ()=>LoginContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../Constants/Routes");
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _localStorageService = require("../../Services/LocalStorageService");
var _localStorageServiceDefault = parcelHelpers.interopDefault(_localStorageService);
var _requests = require("../../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _acceptTermsAndConditionsModal = require("./AcceptTermsAndConditionsModal");
var _acceptTermsAndConditionsModalDefault = parcelHelpers.interopDefault(_acceptTermsAndConditionsModal);
var _loginDisplay = require("./LoginDisplay");
var _loginDisplayDefault = parcelHelpers.interopDefault(_loginDisplay);
var _mfadisplay = require("./MFADisplay");
var _mfadisplayDefault = parcelHelpers.interopDefault(_mfadisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(LoginContainer);
const initState = {
    alertColor: "",
    alertMessage: "",
    alertText: "",
    attemptCount: 3,
    challenge: "",
    clientToken: "",
    email: "",
    error: "",
    hidePassword: true,
    loginRequestPending: false,
    password: "",
    showAcceptTermsModal: false,
    showAlert: false,
    showError: false,
    showMFA: false,
    termsModal: false,
    twoFactorError: ""
};
function LoginContainer(props) {
    const { handleLoginSuccess: parentHandleLoginSuccess, isLoggedIn, setIsLoggedIn } = props;
    const [state, updateState] = (0, _react.useState)(initState);
    const { isBarkoUi, isEnovationUi, isVersatileUi, terms_and_conditions_url } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const api = (0, _react.useMemo)(()=>new (0, _requestsDefault.default)(), []), auth = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), localStorageService = (0, _react.useMemo)(()=>new (0, _localStorageServiceDefault.default)(), []);
    const history = (0, _reactRouterDom.useHistory)(), location = (0, _reactRouterDom.useLocation)();
    const handleLoginSuccess = (0, _react.useCallback)(({ token, user })=>{
        setIsLoggedIn(true);
        auth.setToken(token);
        auth.setUserRootOrgID(user.rootOrgID);
        auth.setCurrentOrgID(user.rootOrgID);
        localStorageService.setObject("permissions", user.permissions);
        parentHandleLoginSuccess();
        history.replace(location?.state?.targetPath ?? (0, _routes.MAP));
    }, [
        auth,
        history,
        localStorageService,
        location?.state?.targetPath,
        parentHandleLoginSuccess,
        setIsLoggedIn
    ]);
    const handleAllTermsAccepted = (0, _react.useCallback)((loginRes)=>{
        handleLoginSuccess(loginRes);
    }, [
        handleLoginSuccess
    ]), handlePropUpdate = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value,
                showError: false
            }));
    }, []), toggleAlert = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showAlert: false
            }));
    }, []), togglePasswordType = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                hidePassword: !prevState.hidePassword
            }));
    }, []), showResetPasswordAlert = (0, _react.useCallback)((alertColor, alertText, alertMessage)=>{
        updateState((prevState)=>{
            window.setTimeout(toggleAlert, 8000);
            return {
                ...prevState,
                alertColor,
                alertMessage,
                alertText,
                showAlert: true,
                showError: false
            };
        });
    }, [
        toggleAlert
    ]), showTwoFactorAlert = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            const sentOrResent = prevState.attemptCount === 3 ? "sent" : "resent";
            window.setTimeout(toggleAlert, 8000);
            return {
                ...prevState,
                alertMessage: `6 digit token has been ${sentOrResent}!`,
                firstAttempt: false,
                showAlert: true,
                showError: false,
                showMFA: true
            };
        });
    }, [
        toggleAlert
    ]), toggleAcceptTermsAndConditionsModal = (0, _react.useCallback)((loginRes = {})=>{
        updateState((prevState)=>({
                ...initState,
                loginRes,
                showAcceptTermsModal: !prevState.showAcceptTermsModal
            }));
    }, []), toggleTermsAndConditionsModal = (0, _react.useCallback)(()=>{
        isBarkoUi || isEnovationUi || isVersatileUi ? window.open(terms_and_conditions_url, "_blank") : updateState((prevState)=>({
                ...prevState,
                termsModal: !prevState.termsModal
            }));
    }, [
        isBarkoUi,
        isEnovationUi,
        isVersatileUi,
        terms_and_conditions_url
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        updateState((prevState)=>({
                ...prevState,
                loginRequestPending: true
            }));
        try {
            const { email, password } = state;
            const { data } = await api.request(auth.buildLoginRequest({
                email,
                password
            }));
            if (data?.hasAcceptedTerms?.every?.(({ accepted })=>accepted)) handleLoginSuccess(data);
            else toggleAcceptTermsAndConditionsModal(data);
        } catch (err) {
            const errorCode = err?.response?.status;
            const clientToken = err?.response?.data?.clientToken;
            const error = errorCode === 400 ? "Invalid email or password" : err?.response?.data?.message ?? "We were not able to process your request. Please try again later.";
            updateState((prevState)=>({
                    ...prevState,
                    clientToken,
                    error,
                    loginRequestPending: false,
                    showError: true
                }));
            if (errorCode === 403) showTwoFactorAlert();
        }
    };
    const handleTwoFactor = async (e)=>{
        e.preventDefault();
        updateState((prevState)=>({
                ...prevState,
                loginRequestPending: true
            }));
        try {
            const { email, clientToken, challenge } = state;
            const { data } = await api.request(auth.buildTwoFactorRequest({
                email,
                clientToken,
                challenge
            }));
            if (data?.hasAcceptedTerms?.every?.(({ accepted })=>accepted)) handleLoginSuccess(data);
            else toggleAcceptTermsAndConditionsModal(data);
        } catch (err) {
            const updatedCount = state.attemptCount - 1;
            if (updatedCount === 0) updateState(initState);
            const errorCode = err?.response?.status;
            const error = errorCode === 400 && updatedCount != 1 ? `Incorrect verification code. ${updatedCount} tries remaining.` : errorCode === 400 && updatedCount === 1 ? `Incorrect verification code. 1 try remaining.` : err?.response?.data?.message ?? "We were not able to process your request. Please try again later.";
            if (updatedCount > 0) updateState((prevState)=>({
                    ...prevState,
                    attemptCount: updatedCount,
                    loginRequestPending: false,
                    showError: true,
                    twoFactorError: error
                }));
        }
    };
    (0, _react.useEffect)(()=>{
        if (!isLoggedIn) return;
        setIsLoggedIn(false);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !state.showMFA ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDisplayDefault.default), {
                ...state,
                handlePropUpdate: handlePropUpdate,
                handleSubmit: handleSubmit,
                togglePasswordType: togglePasswordType,
                toggleTermsAndConditionsModal: toggleTermsAndConditionsModal,
                showResetPasswordAlert: showResetPasswordAlert,
                toggleAlert: toggleAlert
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mfadisplayDefault.default), {
                ...state,
                handlePropUpdate: handlePropUpdate,
                handleSubmit: handleSubmit,
                handleTwoFactor: handleTwoFactor,
                toggleAlert: toggleAlert,
                toggleTermsAndConditionsModal: toggleTermsAndConditionsModal
            }),
            state.showAcceptTermsModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acceptTermsAndConditionsModalDefault.default), {
                handleAllTermsAccepted: handleAllTermsAccepted,
                isOpen: state.showAcceptTermsModal,
                loginRes: state.loginRes,
                toggleModal: ()=>toggleAcceptTermsAndConditionsModal()
            }) : null
        ]
    });
}
LoginContainer.propTypes = {
    handleLoginSuccess: (0, _propTypesDefault.default).func,
    isLoggedIn: (0, _propTypesDefault.default).bool,
    setIsLoggedIn: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","../../Constants/Routes":"3Lt5k","../../Services/AuthService":"8Bjjn","../../Services/LocalStorageService":"3Alt2","../../Lib/Requests":"j1WJQ","../../Context/BrandingContext":"bKKTd","./AcceptTermsAndConditionsModal":"3E9Ug","./LoginDisplay":"efZJT","./MFADisplay":"jB843","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3E9Ug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _loadingCircle = require("../LoadingCircle");
var _loadingCircleDefault = parcelHelpers.interopDefault(_loadingCircle);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
// preload so bundler includes the files
var _8Ef9Fcdd2E034743Be4D609Ddbdbbf6A = require("../../Static/terms/8ef9fcdd-2e03-4743-be4d-609ddbdbbf6a");
exports.default = /*#__PURE__*/ (0, _react.memo)(AcceptTermsAndConditionsModal);
const initState = {
    error: "",
    hasAcceptedTerms: [],
    org_id: "",
    requestPending: false
}, logoutUrl = `${"https"}://${"elevat-api-dev.elevat-iot.com"}:${"443"}/logout`;
function AcceptTermsAndConditionsModal(props) {
    const { handleAllTermsAccepted, loginRes, loginRes: { hasAcceptedTerms, token, user: { _id: userID, Orgs } }, toggleModal } = props;
    const orgIdsToAccept = (0, _react.useMemo)(()=>Orgs[0].path?.split?.(".")?.reverse?.().filter?.((org_id)=>hasAcceptedTerms?.some?.((t)=>t.org_id === org_id && !t.accepted)) ?? [], [
        hasAcceptedTerms,
        Orgs
    ]);
    const [state, updateState] = (0, _react.useState)(()=>({
            ...initState,
            hasAcceptedTerms,
            org_id: orgIdsToAccept[0]
        })), [terms, setTerms] = (0, _react.useState)([]);
    const currentAcceptingIndex = (0, _react.useMemo)(()=>orgIdsToAccept?.findIndex((id)=>id === state.org_id), [
        orgIdsToAccept,
        state.org_id
    ]);
    const handleAcceptClick = (0, _react.useCallback)(async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            const dateOfAcceptance = new Date().toISOString(), { terms_id: termsID } = state.hasAcceptedTerms?.find?.(({ org_id })=>org_id === state.org_id) ?? {}, body = JSON.stringify({
                dateOfAcceptance,
                termsID
            }), acceptTermsUrl = `${"https"}://${"elevat-api-dev.elevat-iot.com"}:${"443"}/org/${state.org_id}/user/${userID}/terms`, requestOptions = {
                body,
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json"
                },
                method: "PUT"
            };
            const res = await window.fetch(acceptTermsUrl, requestOptions), apiError = res.ok ? null : await res.json();
            if (apiError) updateState((prevState)=>({
                    ...prevState,
                    error: apiError.message,
                    requestPending: false
                }));
            else {
                const updatedHasAcceptedTerms = state.hasAcceptedTerms.map((t)=>t.org_id === state.org_id ? {
                        ...t,
                        accepted: true,
                        terms_id: termsID
                    } : t);
                const allTermsAccepted = updatedHasAcceptedTerms.every(({ accepted })=>accepted);
                if (allTermsAccepted) handleAllTermsAccepted(loginRes);
                else {
                    const org_id = orgIdsToAccept[currentAcceptingIndex + 1];
                    updateState((prevState)=>({
                            ...prevState,
                            hasAcceptedTerms: updatedHasAcceptedTerms,
                            org_id,
                            requestPending: false
                        }));
                }
            }
        } catch (err) {
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    }, [
        currentAcceptingIndex,
        handleAllTermsAccepted,
        loginRes,
        orgIdsToAccept,
        state.hasAcceptedTerms,
        state.org_id,
        token,
        userID
    ]);
    const handleDeclineClick = (0, _react.useCallback)(async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            await window.fetch(logoutUrl, {
                headers: {
                    Authorization: token
                },
                method: "POST"
            });
            toggleModal();
        } catch (err) {
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    }, [
        toggleModal,
        token
    ]);
    (0, _react.useEffect)(()=>{
        function fetchTerms() {
            const termsPromises = hasAcceptedTerms.filter(({ org_id })=>org_id === state.org_id).map(async ({ terms_id })=>{
                const componentModule = await require(`../../Static/terms/${terms_id}`);
                const View = componentModule?.default ?? componentModule;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(View, {}, terms_id);
            });
            Promise.all(termsPromises).then(setTerms);
        }
        fetchTerms();
    }, [
        hasAcceptedTerms,
        state.org_id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        backdrop: "static",
        isOpen: props.isOpen,
        scrollable: true,
        toggle: !state.requestPending && handleDeclineClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-0",
                children: [
                    "Terms of Service (",
                    `${currentAcceptingIndex + 1} of ${orgIdsToAccept.length}`,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: terms?.length ? terms : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircleDefault.default), {
                    size: "3x"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "col-12 text-right text-danger nine-tenth-text",
                        children: state.error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "rounded-lg three-quarter-text py-0 px-3",
                        color: "secondary",
                        disabled: state.requestPending,
                        onClick: handleDeclineClick,
                        outline: true,
                        children: "Decline"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn modal-button-submit rounded-lg three-quarter-text py-0 px-3",
                        disabled: state.requestPending,
                        onClick: handleAcceptClick,
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Accept"
                    })
                ]
            })
        ]
    });
}
AcceptTermsAndConditionsModal.propTypes = {
    handleAllTermsAccepted: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    loginRes: (0, _propTypesDefault.default).shape({
        hasAcceptedTerms: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            accepted: (0, _propTypesDefault.default).bool,
            org_id: (0, _propTypesDefault.default).string,
            terms_id: (0, _propTypesDefault.default).string
        })),
        token: (0, _propTypesDefault.default).string,
        user: (0, _propTypesDefault.default).object
    }),
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../LoadingCircle":"aIADA","../ModalLayout":"2RoDj","../../Static/terms/8ef9fcdd-2e03-4743-be4d-609ddbdbbf6a":"bjKkJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjKkJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ElevatTerms = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Effective May 1, 2018"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE ELEVAT-IOT WEBSITE OR SERVICE (THE \u201CSERVICE\u201D). IF YOU USE OR ACCESS THE SERVICE, YOU WILL BE BOUND BY THESE TERMS."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    'By using and accessing the Service, you agree to be bound by these User Terms of Service ("Terms"). To access the Service, you must accept and agree to be bound by the Terms. If you do not agree to all of these Terms, do not use the Service.'
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    'Elevat, Inc. ("Elevat") may amend these Terms at any time by making the revised Terms available at our websites',
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "http://www.elevat-iot.com",
                        children: "www.elevat-iot.com"
                    }),
                    " or",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://protect-us.mimecast.com/s/DzxkBphXQmpfr?domain=app.elevat-iot.com",
                        children: "https://app.elevat-iot.com/"
                    }),
                    " ",
                    "with an updated effective date. Your continued use of the Service will constitute your acceptance of the Terms as amended."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "By using the Service, you also agree to be bound by the Privacy Policy located ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "http://www.elevat-iot.com/privacypolicy",
                        children: "here"
                    }),
                    " in its then-current form.",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "1. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Obligations"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            "When creating an account or when using the Service, you agree to:",
                            " "
                        ]
                    }),
                    "(1) provide accurate information to us at all times and promptly update any information provided, including your profile or any other account information; (2) keep your access credentials confidential and secure and to promptly notify us if they are compromised; and (3) promptly update any compromised credentials to new credentials and take other steps that you or we may deem necessary to protect your account."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You are responsible for any inaccurate information you provide in connection with the Service and any actions taken under your account credentials, regardless of whether such actions are taken by you or a third party. We are not liable for any loss or damage arising from any unauthorized use of your account."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "2. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Qualifications"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You represent and warrant that you (1) are at least 18 years of age and a resident of the US, if you are an individual, (2) are legally and validly organized under US law, if you are an organization or entity, and (3) have the authority to enter into legally binding contracts for yourself or your legal entity under applicable law."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "3. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Information and Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "When setting up an account on the Service, you will submit certain information necessary to create an account with Elevat (\u201CUser Information\u201D). Other than as specifically requested by Elevat to establish your account, or retrieved by Elevat in the normal course of your use of the Service, you will not submit any personally identifiable information to Elevat at any time."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "By accessing and using the Service, you agree and consent to collection of certain information by the Service, and to the storage and use, of such information by Elevat, in its discretion. Notwithstanding any other provision of these Terms, all information that is collected from you by Elevat and all information that you share, transmit, or otherwise make available to Elevat, including all personally identifiable information which has been de-identified data, constitutes \u201CData\u201D; provided however, that \u201CData\u201D does not include personally identifiable information."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You grant us and our affiliates and related entities, a worldwide, royalty-free, perpetual, irrevocable, non-exclusive right and fully sub-licensable license to use, copy, reproduce, distribute, publish, publicly perform, publicly display, modify, adapt, translate, archive, store, and create derivative works from all Data, in any form, format, or medium, of any kind now known or later developed. You waive any moral rights you might have with respect to any Data. You also grant us the right to use any material, information, ideas, concepts, know-how or techniques contained in any Data for any purpose whatsoever, including but not limited to, commercial purposes, and developing, manufacturing and marketing commercial products using such information. We may also aggregate Data with other information in such a way that it will not identify you and we may use that aggregated Data to develop and improve our products and services. All rights in this paragraph are granted without the need for us to pay compensation of any sort to you."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You agree that any materials, including but not limited to questions, comments, suggestions, ideas, plans, notes, drawings, original or creative materials or other information regarding us or the Service that you provide to us, whether in email, feedback forms, or other submission format, shall belong exclusively to us, without acknowledgement or compensation to you."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "In addition, we may use or disclose any Data or other information that we reasonably believe is necessary to: (1) satisfy legal requirements or governmental requests; (2) enforce or investigate violations of these Terms; (3) detect, prevent, or otherwise address fraud, security, or technical issues; (4) respond to your user support requests; (5) protect the rights, property, or safety of Elevat, our users, and the public."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "4. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Prohibited Uses"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You agree not to engage in any of the following activities while using or accessing the Service and you acknowledge and agree that violating these prohibitions constitutes a breach of these Terms:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Violating local, state, or other applicable laws or regulations;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Posting content that infringes the intellectual property rights, privacy, publicity, or other rights of any third party;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Posting content that is unlawful, obscene, defamatory, threatening, harassing, hateful, or embarrassing to any party as determined in our sole discretion;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Impersonating a third party or implying you are someone other than who you are;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Distributing viruses or other harmful or malicious computer code;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Collecting information about others without their explicit written consent;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Providing your access credentials or otherwise allowing a third party or third party system to use your identification, to pretend they are you, or to access your account; or"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Engaging in any conduct that disrupts or impedes a third party's use and enjoyment of the Service, or which, in our judgment, exposes us or any customers, partners or related entities to liability or detriment of any type."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "5. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Limited License to Use Service"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'Elevat grants you limited, revocable, non-sublicensable license to access and use the Service and all content, data, information, and materials included by Elevat in the Service (the "Elevat Materials") solely for your own personal use, or if you are a commercial customer, solely for your internal business use, subject to the terms and conditions set forth in these Terms. All other rights are reserved. You agree that you will not modify, copy, distribute, resell, transmit, display, perform, reproduce, publish, license, create derivative works from, frame in another web page, or use the Service or Elevat Materials except as explicitly authorized in these Terms. You will not use the Service or any of the Elevat Materials other than for their intended purpose or in any way that is unlawful or harms us or our suppliers.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'Without limiting the foregoing, you may not engage or attempt to engage in the practices of "screen scraping," "database scraping," "data mining" or any other activity with the purpose of obtaining lists of users or other information from the Service or that uses web "bots" or similar data gathering or extraction methods, or knowingly permit use of your access credentials by another party to do so. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Service.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "6. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Suspension and Termination"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Elevat can, in its sole discretion, suspend access to your account on the Service if we believe: (1) there is risk to the security or privacy of your account; (2) there is a threat to the security or integrity of our network or the Service; (3) suspension is needed to protect the rights, property or safety of Elevat, our users or the public; (4) there is a basis for termination of your account; or (5) you have violated these Terms; or (6) we are required to by law."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "We may cancel your access to the Service: (1) immediately if you breach these Terms; (2) there is a basis for cancellation of your account based on another agreement in place between us; or (2) if required by law. We will provide you notice if we cancel your account."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "We will endeavor to promptly provide you notice in the event of any suspension or termination. During a suspension or following a termination, you will not have the ability to use or access the Service and other information contained or stored by you in, or as part of, the Service will no longer be accessible to you. Any suspension of your access to the Service will not limit or waive our rights to terminate your access to the Service. At the point we determine, in our sole discretion, that the reason for suspension of access to your account has been resolved, we will restore access to your account. During a suspension or following a termination, you will not register or attempt to register another account with Elevat."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "These Terms terminate upon cancellation of your account. Upon termination, Elevat has no obligation to store your data, but may do so to comply with legal or business requirements for a reasonable time after termination."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You may cancel your account at any time by emailing cancel@elevat-iot.com."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "7. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Disclaimer of Warranty and Limitation of Liability"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE SERVICE IS AT YOUR OWN RISK. THE SERVICE IS PROVIDED "AS IS", WITHOUT WARRANTIES OF ANY KIND. ELEVAT, TO THE FULLEST EXTENT ALLOWED BY THE LAW, EXPRESSLY DISCLAIMS ANY / ALL WARRANTIES, EITHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE. ELEVAT SHALL HAVE ABSOLUTELY NO LIABILITY IN CONNECTION WITH THE SERVICE INCLUDING WITHOUT LIMITATION, ANY LIABILITY FOR DAMAGE TO YOUR COMPUTER HARDWARE, SOFTWARE, LOSS OF DATA, LOSS OF BUSINESS, INABILITY TO ACCESS DATA OR THE SERVICE, OR THE LACK OF INFORMATION IN ANY WAY RELATING TO THE SERVICE. WHILE WE ATTEMPT TO ENSURE THAT YOUR ACCESS TO AND USE OF THE SERVICE IS SAFE, RELIABLE, AND ERROR-FREE, ELEVAT CANNOT GUARANTEE, AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, OR ANY ELEMENT THEREOF, INCLUDING SOFTWARE OR SYSTEMS ARE AVAILABLE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "IN NO EVENT WILL ELEVAT\u2019S TOTAL LIABILITY TO YOU FOR ALL DAMAGES ARISING FOR YOUR USE OF THE SERVICE OR INFORMATION, MATERIALS, OR PRODUCTS MADE AVAILABLE TO YOU THROUGH THE SERVICE EXCEED THE GREATER OF $100 OR THE AMOUNT YOU PAID TO ELEVAT FOR THE AFFECTED MATERIALS. IN NO EVENT WILL ELEVAT BE LIABLE FOR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES, PERSONAL INJURY/WRONGFUL DEATH, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION RESULTING FROM THE ACCESS TO, USE OF, OR RELIANCE ON, THE SERVICE, APPS OR IN-APP PRODUCTS WHETHER BASED ON WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL THEORY, WHETHER OR NOT ELEVAT IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THESE LIMITATIONS WILL APPLY TO YOU EVEN IF THE REMEDIES FAIL OF THEIR ESSENTIAL PURPOSE."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "8. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Indemnity"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You agree to defend, indemnify and hold Elevat, its officers, directors, employees, agents, licensors and business partners, harmless from and against any claims, actions or demands, liabilities and settlements including without limitation, reasonable legal and accounting fees, resulting from, or alleged to result from, your violation of these Terms."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "9. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Geographic Restrictions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Elevat is based in the United States of America. Elevat makes no claims that the Service is appropriate or may be used outside of the United States. Access to and use of the Service is intended solely for persons residing in the United States and may not be legal by certain persons or in certain countries. If you use the Service from outside the United States, you do so at your own risk and are responsible for compliance with the laws of your jurisdiction."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "10. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Jurisdiction and Venue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "These Terms are governed by and construed in accordance with the laws of the State of Washington, without regard to its conflict of law principles. You expressly agree that exclusive jurisdiction for any dispute with Elevat, or in any way relating to the Service, resides in the state and federal courts in Seattle, Washington, and you hereby expressly, irrevocably, and unconditionally consent and submit to the exercise of personal jurisdiction by such courts."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "11. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "General"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "If any part of the Terms is determined to be invalid or unenforceable pursuant to applicable law, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the Terms will continue in effect. You may not assign these Terms, or assign, transfer or sublicense your rights, if any, in the Service, however, Elevat may freely assign these Terms. Unless expressly stated in another written agreement between you and us, the Terms constitute the entire agreement between you and us with respect to the Service. You agree and consent to receive communications from us via each of the following methods: by posting or making available such communication within the Service or by sending such communication to the email address you provided as part of your account. You agree that all agreements, notices, disclosures and other communications that we may provide to you electronically satisfy any legal requirement that such communications be in writing."
            })
        ]
    });
exports.default = ElevatTerms;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"efZJT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _centerContainer = require("../CenterContainer");
var _centerContainerDefault = parcelHelpers.interopDefault(_centerContainer);
var _trackerClasses = require("../../Constants/TrackerClasses");
var _termsAndConditionsTemplate = require("./TermsAndConditionsTemplate");
var _termsAndConditionsTemplateDefault = parcelHelpers.interopDefault(_termsAndConditionsTemplate);
var _resetPasswordContainer = require("./ResetPasswordContainer");
var _resetPasswordContainerDefault = parcelHelpers.interopDefault(_resetPasswordContainer);
exports.default = /*#__PURE__*/ (0, _react.memo)(LoginDisplay);
const { className: alertClass, styles: alertStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "327255241",
        children: ".alert.jsx-327255241{z-index:10000;right:12.5%;top:5rem;opacity:0.9;}"
    }),
    className: "jsx-327255241"
};
const { className: inputClass, styles: inputStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1193078894",
        children: "input.jsx-1193078894{border-radius:15px;}input.jsx-1193078894::-webkit-input-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894::-moz-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894:-ms-input-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894::placeholder{color:var(--icon-link-gray);}.form-control.jsx-1193078894:focus{outline:none;}input.jsx-1193078894::-webkit-credentials-auto-fill-button{visibility:hidden;display:none !important;pointer-events:none;position:absolute;right:0;}input.jsx-1193078894:-webkit-autofill{-webkit-box-shadow:0 0 0px 1000px white inset;}"
    }),
    className: "jsx-1193078894"
};
const { className: eyeButtonClass, styles: eyeButtonStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "362388298",
        children: "button.jsx-362388298{color:#21363e;outline:none;border-color:var(--input-border-gray);border-radius:0 15px 15px 0;}button.jsx-362388298:active{border-color:var(--input-border-gray);border-style:double;outline:transparent;}"
    }),
    className: "jsx-362388298"
};
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "4264976005",
        children: "@media (max-width:767px){.modal-dialog.jsx-4264976005{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}.modal-body.jsx-4264976005{max-height:calc(100vh - 123px);overflow-y:auto;}}@media (min-width:768px){.modal-body.jsx-4264976005{max-height:60vh;overflow-y:auto;}}"
    }),
    className: "jsx-4264976005"
};
function LoginDisplay(props) {
    const { alertColor, alertMessage, alertText, email, error, handleSubmit, handlePropUpdate, hidePassword, loginRequestPending, password, showAlert, showError, showResetPasswordAlert, termsModal, toggleAlert, togglePasswordType, toggleTermsAndConditionsModal } = props;
    const [showResetPasswordModal, toggleResetPasswordModal] = (0, _react.useState)(false);
    const { isElevatUi, isEnovationUi, isSupraUi, isVersatileUi, logo_url, tige_login_logo_url } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const isTigeDemoUi = window.location.host?.includes("tige");
    const hideConnectingText = isVersatileUi || isSupraUi || isTigeDemoUi;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _centerContainerDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Alert), {
                color: alertColor,
                isOpen: showAlert,
                toggle: toggleAlert,
                className: `${alertClass} position-fixed w-75 border-0`,
                closeClassName: `${alertText}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "3094553006",
                            [
                                isVersatileUi ? "500" : "550",
                                isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                isVersatileUi ? "550" : "600"
                            ]
                        ]
                    ]) + " " + `d-flex align-items-center justify-content-center text-white alert-font-size`,
                    children: alertMessage
                })
            }),
            alertStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Container), {
                fluid: true,
                className: "p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "3094553006",
                                [
                                    isVersatileUi ? "500" : "550",
                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                    isVersatileUi ? "550" : "600"
                                ]
                            ]
                        ]) + " " + "col align-self-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "3094553006",
                                        [
                                            isVersatileUi ? "500" : "550",
                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                            isVersatileUi ? "550" : "600"
                                        ]
                                    ]
                                ]) + " " + "outer-container d-flex flex-column mx-auto shadow p-3 bg-white rounded",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                        xs: {
                                            size: 10,
                                            offset: 1
                                        },
                                        md: {
                                            size: 6,
                                            offset: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "3094553006",
                                                        [
                                                            isVersatileUi ? "500" : "550",
                                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                            isVersatileUi ? "550" : "600"
                                                        ]
                                                    ]
                                                ]) + " " + `text-center mt-${hideConnectingText ? "4" : "2"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                                        className: isElevatUi ? "" : isSupraUi ? "mb-5" : "mb-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            alt: "brand",
                                                            src: isTigeDemoUi ? tige_login_logo_url : logo_url,
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "3094553006",
                                                                    [
                                                                        isVersatileUi ? "500" : "550",
                                                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                        isVersatileUi ? "550" : "600"
                                                                    ]
                                                                ]
                                                            ]) + " " + "login-logo image-fluid mw-100 mx-auto"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "3094553006",
                                                                [
                                                                    isVersatileUi ? "500" : "550",
                                                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                    isVersatileUi ? "550" : "600"
                                                                ]
                                                            ]
                                                        ]) + " " + ((hideConnectingText ? "d-none" : `text-center text-elevat-blue three-quarter-text mx-auto mb-${isEnovationUi ? "2" : "4"}`) || ""),
                                                        children: "Connecting the Industrial World"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "3094553006",
                                                                [
                                                                    isVersatileUi ? "500" : "550",
                                                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                    isVersatileUi ? "550" : "600"
                                                                ]
                                                            ]
                                                        ]) + " " + "font-weight-light text-center text-text-light-gray three-quarter-text mb-4",
                                                        children: "Sign in to start managing your IoT assets."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Form), {
                                                onSubmit: handleSubmit,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                                                        row: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                                className: "mt-1 ml-2",
                                                                for: "login-email",
                                                                children: "Email"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                                className: `${inputClass} border-${showError ? "danger" : isVersatileUi ? "input-border-gray" : isSupraUi ? "dark" : "elevat-blue"} bg-white shadow-none`,
                                                                type: "email",
                                                                name: "email",
                                                                id: "login-email",
                                                                value: email,
                                                                placeholder: "name@company.com",
                                                                onChange: handlePropUpdate,
                                                                invalid: showError
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                                                        className: "mb-0",
                                                        row: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                                className: "ml-2",
                                                                for: "login-password",
                                                                children: "Password"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "3094553006",
                                                                        [
                                                                            isVersatileUi ? "500" : "550",
                                                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                            isVersatileUi ? "550" : "600"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "input-group",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                                        className: `${inputClass} border-${showError ? "danger" : isVersatileUi ? "input-border-gray" : isSupraUi ? "dark" : "elevat-blue"} shadow-none bg-white border-right-0`,
                                                                        type: hidePassword ? "password" : "text",
                                                                        id: "login-password",
                                                                        placeholder: "password",
                                                                        name: "password",
                                                                        value: password,
                                                                        onChange: handlePropUpdate,
                                                                        invalid: showError
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: (0, _styleDefault.default).dynamic([
                                                                            [
                                                                                "3094553006",
                                                                                [
                                                                                    isVersatileUi ? "500" : "550",
                                                                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                                    isVersatileUi ? "550" : "600"
                                                                                ]
                                                                            ]
                                                                        ]) + " " + "input-group-append",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: togglePasswordType,
                                                                            className: (0, _styleDefault.default).dynamic([
                                                                                [
                                                                                    "3094553006",
                                                                                    [
                                                                                        isVersatileUi ? "500" : "550",
                                                                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                                        isVersatileUi ? "550" : "600"
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + `btn btn-link ${eyeButtonClass} border-${showError ? "danger" : isVersatileUi ? "input-border-gray" : isSupraUi ? "dark" : "elevat-blue"} input-group-text border-left-0 bg-transparent`,
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                                icon: hidePassword ? (0, _freeSolidSvgIcons.faEye) : (0, _freeSolidSvgIcons.faEyeSlash)
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "3094553006",
                                                                [
                                                                    isVersatileUi ? "500" : "550",
                                                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                    isVersatileUi ? "550" : "600"
                                                                ]
                                                            ]
                                                        ]) + " " + "error-container row align-items-center",
                                                        children: showError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "3094553006",
                                                                    [
                                                                        isVersatileUi ? "500" : "550",
                                                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                        isVersatileUi ? "550" : "600"
                                                                    ]
                                                                ]
                                                            ]) + " " + `text-danger error-text ${0, _trackerClasses.ERROR_LOGIN_FORM}`,
                                                            children: error
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "submit",
                                                            disabled: loginRequestPending,
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "3094553006",
                                                                    [
                                                                        isVersatileUi ? "500" : "550",
                                                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                        isVersatileUi ? "550" : "600"
                                                                    ]
                                                                ]
                                                            ]) + " " + `btn login-button${isVersatileUi ? "-versatile" : ""} flex-grow-1 form-border-radius d-flex align-items-center justify-content-center`,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "3094553006",
                                                                        [
                                                                            isVersatileUi ? "500" : "550",
                                                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                            isVersatileUi ? "550" : "600"
                                                                        ]
                                                                    ]
                                                                ]) + " " + `login-button-text${isVersatileUi ? "-versatile" : ""}`,
                                                                children: loginRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                                    spin: true,
                                                                    size: "lg"
                                                                }) : "Sign In"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "3094553006",
                                                        [
                                                            isVersatileUi ? "500" : "550",
                                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                            isVersatileUi ? "550" : "600"
                                                        ]
                                                    ]
                                                ]) + " " + "row text-center",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>toggleResetPasswordModal(!showResetPasswordModal),
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "3094553006",
                                                            [
                                                                isVersatileUi ? "500" : "550",
                                                                isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                                isVersatileUi ? "550" : "600"
                                                            ]
                                                        ]
                                                    ]) + " " + "btn btn-link mx-auto forgot-password login-form-link text-decoration-none shadow-none",
                                                    children: "Forgot your password?"
                                                })
                                            })
                                        ]
                                    }),
                                    !isVersatileUi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "3094553006",
                                                [
                                                    isVersatileUi ? "500" : "550",
                                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                                    isVersatileUi ? "550" : "600"
                                                ]
                                            ]
                                        ]) + " " + "mt-auto",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginFooterDisplay, {
                                            termsModal: termsModal,
                                            toggleTermsAndConditionsModal: toggleTermsAndConditionsModal
                                        })
                                    }) : null
                                ]
                            }),
                            isVersatileUi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    maxWidth: "620px"
                                },
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "3094553006",
                                        [
                                            isVersatileUi ? "500" : "550",
                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                                            isVersatileUi ? "550" : "600"
                                        ]
                                    ]
                                ]) + " " + "mx-auto mt-1 text-white",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginFooterDisplay, {
                                    termsModal: termsModal,
                                    toggleTermsAndConditionsModal: toggleTermsAndConditionsModal
                                })
                            }) : null
                        ]
                    })
                })
            }),
            showResetPasswordModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordContainerDefault.default), {
                isOpen: showResetPasswordModal,
                toggleModal: ()=>toggleResetPasswordModal(!showResetPasswordModal),
                toggleAlert: toggleAlert,
                showResetPasswordAlert: showResetPasswordAlert
            }) : null,
            inputStyles,
            eyeButtonStyles,
            modalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3094553006",
                dynamic: [
                    isVersatileUi ? "500" : "550",
                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue",
                    isVersatileUi ? "550" : "600"
                ],
                children: `.outer-container.__jsx-style-dynamic-selector{height:${isVersatileUi ? "500" : "550"}px;max-width:620px;color:var(--black-text);}.login-logo.__jsx-style-dynamic-selector{max-height:70px;}.login-button.__jsx-style-dynamic-selector{background-color:var(--login-button-background-color);border:none;cursor:pointer;height:38px;}.login-button.__jsx-style-dynamic-selector:focus,.login-button.__jsx-style-dynamic-selector:hover{background-color:var(--login-button-hover-background-color);outline:none;}.login-button-versatile.__jsx-style-dynamic-selector{background-color:var(--white);border-color:var(--brand-primary);color:var(--brand-primary);cursor:pointer;height:38px;}.login-button-versatile.__jsx-style-dynamic-selector:focus,.login-button-versatile.__jsx-style-dynamic-selector:hover{background-color:var(--brand-primary);color:var(--white);}.login-button-text.__jsx-style-dynamic-selector{color:var(--white);font-size:1.2rem;}.login-button-text-versatile.__jsx-style-dynamic-selector{color:inherit;font-size:1.2rem;}.login-button-text-versatile.__jsx-style-dynamic-selector:focus,.login-button-text-versatile.__jsx-style-dynamic-selector:hover{color:var(--white);}.forgot-password.__jsx-style-dynamic-selector{color:var(--black-text);font-size:0.75rem;}.login-form-link.__jsx-style-dynamic-selector{font-size:0.8rem !important;color:var(--black-text);}.login-form-link.__jsx-style-dynamic-selector:hover{color:var( --${isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"} ) !important;}.form-border-radius.__jsx-style-dynamic-selector{border-radius:15px;}.error-container.__jsx-style-dynamic-selector{height:40px;}.error-text.__jsx-style-dynamic-selector{margin-left:10px;font-size:0.81rem;}@media (min-width:768px){.login-logo.__jsx-style-dynamic-selector{max-height:100px;}.login-form-footer.__jsx-style-dynamic-selector{margin-top:55px;}.outer-container.__jsx-style-dynamic-selector{height:${isVersatileUi ? "550" : "600"}px;}}`
            })
        ]
    });
}
LoginDisplay.propTypes = {
    alertColor: (0, _propTypesDefault.default).string,
    alertMessage: (0, _propTypesDefault.default).string,
    alertText: (0, _propTypesDefault.default).string,
    email: (0, _propTypesDefault.default).string,
    error: (0, _propTypesDefault.default).string,
    forgotModal: (0, _propTypesDefault.default).bool,
    handleSubmit: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    hidePassword: (0, _propTypesDefault.default).bool,
    loginRequestPending: (0, _propTypesDefault.default).bool,
    password: (0, _propTypesDefault.default).string,
    showAlert: (0, _propTypesDefault.default).bool,
    showError: (0, _propTypesDefault.default).bool,
    showResetPasswordAlert: (0, _propTypesDefault.default).func,
    termsModal: (0, _propTypesDefault.default).bool,
    toggleAlert: (0, _propTypesDefault.default).func,
    togglePasswordType: (0, _propTypesDefault.default).func,
    toggleTermsAndConditionsModal: (0, _propTypesDefault.default).func
};
function LoginFooterDisplay(props) {
    const { contact_url, isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _styleDefault.default).dynamic([
            [
                "841001645",
                [
                    isVersatileUi ? "text-white" : "elevat-blue",
                    isVersatileUi ? "elevat-blue" : "black-text",
                    isSupraUi ? "brand-primary" : "highlight-blue"
                ]
            ]
        ]) + " " + "login-form-footer d-flex flex-column justify-content-center align-items-center flex-md-row justify-content-md-between align-items-md-end",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "841001645",
                        [
                            isVersatileUi ? "text-white" : "elevat-blue",
                            isVersatileUi ? "elevat-blue" : "black-text",
                            isSupraUi ? "brand-primary" : "highlight-blue"
                        ]
                    ]
                ]) + " " + "text-nowrap pl-lg-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "841001645",
                                [
                                    isVersatileUi ? "text-white" : "elevat-blue",
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "branded-text",
                        children: "powered by "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "841001645",
                                [
                                    isVersatileUi ? "text-white" : "elevat-blue",
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "branded-text font-weight-light",
                        children: "elev\u0101t"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "841001645",
                        [
                            isVersatileUi ? "text-white" : "elevat-blue",
                            isVersatileUi ? "elevat-blue" : "black-text",
                            isSupraUi ? "brand-primary" : "highlight-blue"
                        ]
                    ]
                ]) + " " + "text-nowrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "841001645",
                                [
                                    isVersatileUi ? "text-white" : "elevat-blue",
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "branded-text",
                        children: "Don't have an account?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: contact_url,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "841001645",
                                [
                                    isVersatileUi ? "text-white" : "elevat-blue",
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "login-form-link ml-2 text-decoration-none shadow-none",
                        children: "Contact Us"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "841001645",
                        [
                            isVersatileUi ? "text-white" : "elevat-blue",
                            isVersatileUi ? "elevat-blue" : "black-text",
                            isSupraUi ? "brand-primary" : "highlight-blue"
                        ]
                    ]
                ]) + " " + "text-nowrap pr-lg-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: props.toggleTermsAndConditionsModal,
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "841001645",
                            [
                                isVersatileUi ? "text-white" : "elevat-blue",
                                isVersatileUi ? "elevat-blue" : "black-text",
                                isSupraUi ? "brand-primary" : "highlight-blue"
                            ]
                        ]
                    ]) + " " + "btn m-0 p-0 login-form-link text-decoration-none shadow-none",
                    children: "Terms and Conditions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
                className: modalClass,
                isOpen: props.termsModal,
                toggle: props.toggleTermsAndConditionsModal,
                style: {
                    maxWidth: "620px"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                        className: "border-0",
                        toggle: props.toggleTermsAndConditionsModal,
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                        className: `${modalClass} text-left`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsAndConditionsTemplateDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: props.toggleTermsAndConditionsModal,
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "841001645",
                                    [
                                        isVersatileUi ? "text-white" : "elevat-blue",
                                        isVersatileUi ? "elevat-blue" : "black-text",
                                        isSupraUi ? "brand-primary" : "highlight-blue"
                                    ]
                                ]
                            ]) + " " + "btn btn-outline-secondary py-0 px-3 mr-3",
                            children: "Close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "841001645",
                dynamic: [
                    isVersatileUi ? "text-white" : "elevat-blue",
                    isVersatileUi ? "elevat-blue" : "black-text",
                    isSupraUi ? "brand-primary" : "highlight-blue"
                ],
                children: `.login-form-footer.__jsx-style-dynamic-selector{font-size:0.8rem;line-height:1.2rem;}.branded-text.__jsx-style-dynamic-selector{color:var(--${isVersatileUi ? "text-white" : "elevat-blue"});}.login-form-link.__jsx-style-dynamic-selector{font-size:0.8rem !important;color:var(--${isVersatileUi ? "elevat-blue" : "black-text"});}.login-form-link.__jsx-style-dynamic-selector:focus,.login-form-link.__jsx-style-dynamic-selector:hover{color:var( --${isSupraUi ? "brand-primary" : "highlight-blue"} ) !important;}`
            })
        ]
    });
}
LoginFooterDisplay.propTypes = {
    termsModal: (0, _propTypesDefault.default).bool,
    toggleTermsAndConditionsModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/BrandingContext":"bKKTd","../CenterContainer":"c36BU","../../Constants/TrackerClasses":"1AdWb","./TermsAndConditionsTemplate":"5bH2W","./ResetPasswordContainer":"4v17f","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c36BU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _brandingContext = require("../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _iconsContext = require("../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
exports.default = /*#__PURE__*/ (0, _react.memo)(CenterContainer);
function CenterContainer(props) {
    const { isBarkoUi, isBrandedExperienceUi, isCustomerDemoUi, isEnovationUi, isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const { loginBackgroundImage, tigeLoginBackgroundImage } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const isTigeDemoUi = window.location.host?.includes("tige");
    const loginUrl = isTigeDemoUi ? tigeLoginBackgroundImage : loginBackgroundImage;
    const backgroundGradientRgba = isEnovationUi || isSupraUi ? "0, 0, 0, 0.0" : isBarkoUi || isVersatileUi ? "204, 0, 0, 0.0" : `131, 191, 203, ${isBrandedExperienceUi || isCustomerDemoUi || isTigeDemoUi ? "0.2" : "0.66"}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _styleDefault.default).dynamic([
            [
                "431214627",
                [
                    backgroundGradientRgba,
                    backgroundGradientRgba,
                    loginUrl
                ]
            ]
        ]) + " " + "center-container min-vh-100 min-wh-100 d-flex flex-wrap justify-content-center align-items-center",
        children: [
            props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "431214627",
                dynamic: [
                    backgroundGradientRgba,
                    backgroundGradientRgba,
                    loginUrl
                ],
                children: `.center-container.__jsx-style-dynamic-selector{background: linear-gradient( rgba(${backgroundGradientRgba}), rgba(${backgroundGradientRgba}) ), url(${loginUrl}) no-repeat center center fixed;background-size:cover;}`
            })
        ]
    });
}
CenterContainer.propTypes = {
    children: (0, _propTypesDefault.default).node
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","../Context/BrandingContext":"bKKTd","../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bH2W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TermsAndConditions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function TermsAndConditions() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Effective May 1, 2018"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE ELEVAT-IOT WEBSITE OR SERVICE (THE \u201CSERVICE\u201D). IF YOU USE OR ACCESS THE SERVICE, YOU WILL BE BOUND BY THESE TERMS."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    'By using and accessing the Service, you agree to be bound by these User Terms of Service ("Terms"). To access the Service, you must accept and agree to be bound by the Terms. If you do not agree to all of these Terms, do not use the Service.'
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    'Elevat, Inc. ("Elevat") may amend these Terms at any time by making the revised Terms available at our websites',
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "http://www.elevat-iot.com",
                        children: "www.elevat-iot.com"
                    }),
                    " or",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://protect-us.mimecast.com/s/DzxkBphXQmpfr?domain=app.elevat-iot.com",
                        children: "https://app.elevat-iot.com/"
                    }),
                    " ",
                    "with an updated effective date. Your continued use of the Service will constitute your acceptance of the Terms as amended."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "By using the Service, you also agree to be bound by the Privacy Policy located ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "http://www.elevat-iot.com/privacypolicy",
                        children: "here"
                    }),
                    " in its then-current form.",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "1. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Obligations"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            "When creating an account or when using the Service, you agree to:",
                            " "
                        ]
                    }),
                    "(1) provide accurate information to us at all times and promptly update any information provided, including your profile or any other account information; (2) keep your access credentials confidential and secure and to promptly notify us if they are compromised; and (3) promptly update any compromised credentials to new credentials and take other steps that you or we may deem necessary to protect your account."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You are responsible for any inaccurate information you provide in connection with the Service and any actions taken under your account credentials, regardless of whether such actions are taken by you or a third party. We are not liable for any loss or damage arising from any unauthorized use of your account."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "2. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Qualifications"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You represent and warrant that you (1) are at least 18 years of age and a resident of the US, if you are an individual, (2) are legally and validly organized under US law, if you are an organization or entity, and (3) have the authority to enter into legally binding contracts for yourself or your legal entity under applicable law."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "3. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "User Information and Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "When setting up an account on the Service, you will submit certain information necessary to create an account with Elevat (\u201CUser Information\u201D). Other than as specifically requested by Elevat to establish your account, or retrieved by Elevat in the normal course of your use of the Service, you will not submit any personally identifiable information to Elevat at any time."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "By accessing and using the Service, you agree and consent to collection of certain information by the Service, and to the storage and use, of such information by Elevat, in its discretion. Notwithstanding any other provision of these Terms, all information that is collected from you by Elevat and all information that you share, transmit, or otherwise make available to Elevat, including all personally identifiable information which has been de-identified data, constitutes \u201CData\u201D; provided however, that \u201CData\u201D does not include personally identifiable information."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You grant us and our affiliates and related entities, a worldwide, royalty-free, perpetual, irrevocable, non-exclusive right and fully sub-licensable license to use, copy, reproduce, distribute, publish, publicly perform, publicly display, modify, adapt, translate, archive, store, and create derivative works from all Data, in any form, format, or medium, of any kind now known or later developed. You waive any moral rights you might have with respect to any Data. You also grant us the right to use any material, information, ideas, concepts, know-how or techniques contained in any Data for any purpose whatsoever, including but not limited to, commercial purposes, and developing, manufacturing and marketing commercial products using such information. We may also aggregate Data with other information in such a way that it will not identify you and we may use that aggregated Data to develop and improve our products and services. All rights in this paragraph are granted without the need for us to pay compensation of any sort to you."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You agree that any materials, including but not limited to questions, comments, suggestions, ideas, plans, notes, drawings, original or creative materials or other information regarding us or the Service that you provide to us, whether in email, feedback forms, or other submission format, shall belong exclusively to us, without acknowledgement or compensation to you."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "In addition, we may use or disclose any Data or other information that we reasonably believe is necessary to: (1) satisfy legal requirements or governmental requests; (2) enforce or investigate violations of these Terms; (3) detect, prevent, or otherwise address fraud, security, or technical issues; (4) respond to your user support requests; (5) protect the rights, property, or safety of Elevat, our users, and the public."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "4. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Prohibited Uses"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You agree not to engage in any of the following activities while using or accessing the Service and you acknowledge and agree that violating these prohibitions constitutes a breach of these Terms:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Violating local, state, or other applicable laws or regulations;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Posting content that infringes the intellectual property rights, privacy, publicity, or other rights of any third party;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Posting content that is unlawful, obscene, defamatory, threatening, harassing, hateful, or embarrassing to any party as determined in our sole discretion;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Impersonating a third party or implying you are someone other than who you are;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Distributing viruses or other harmful or malicious computer code;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Collecting information about others without their explicit written consent;"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Providing your access credentials or otherwise allowing a third party or third party system to use your identification, to pretend they are you, or to access your account; or"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "\u2022 Engaging in any conduct that disrupts or impedes a third party's use and enjoyment of the Service, or which, in our judgment, exposes us or any customers, partners or related entities to liability or detriment of any type."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "5. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Limited License to Use Service"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'Elevat grants you limited, revocable, non-sublicensable license to access and use the Service and all content, data, information, and materials included by Elevat in the Service (the "Elevat Materials") solely for your own personal use, or if you are a commercial customer, solely for your internal business use, subject to the terms and conditions set forth in these Terms. All other rights are reserved. You agree that you will not modify, copy, distribute, resell, transmit, display, perform, reproduce, publish, license, create derivative works from, frame in another web page, or use the Service or Elevat Materials except as explicitly authorized in these Terms. You will not use the Service or any of the Elevat Materials other than for their intended purpose or in any way that is unlawful or harms us or our suppliers.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'Without limiting the foregoing, you may not engage or attempt to engage in the practices of "screen scraping," "database scraping," "data mining" or any other activity with the purpose of obtaining lists of users or other information from the Service or that uses web "bots" or similar data gathering or extraction methods, or knowingly permit use of your access credentials by another party to do so. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Service.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "6. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Suspension and Termination"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Elevat can, in its sole discretion, suspend access to your account on the Service if we believe: (1) there is risk to the security or privacy of your account; (2) there is a threat to the security or integrity of our network or the Service; (3) suspension is needed to protect the rights, property or safety of Elevat, our users or the public; (4) there is a basis for termination of your account; or (5) you have violated these Terms; or (6) we are required to by law."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "We may cancel your access to the Service: (1) immediately if you breach these Terms; (2) there is a basis for cancellation of your account based on another agreement in place between us; or (2) if required by law. We will provide you notice if we cancel your account."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "We will endeavor to promptly provide you notice in the event of any suspension or termination. During a suspension or following a termination, you will not have the ability to use or access the Service and other information contained or stored by you in, or as part of, the Service will no longer be accessible to you. Any suspension of your access to the Service will not limit or waive our rights to terminate your access to the Service. At the point we determine, in our sole discretion, that the reason for suspension of access to your account has been resolved, we will restore access to your account. During a suspension or following a termination, you will not register or attempt to register another account with Elevat."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "These Terms terminate upon cancellation of your account. Upon termination, Elevat has no obligation to store your data, but may do so to comply with legal or business requirements for a reasonable time after termination."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "You may cancel your account at any time by emailing cancel@elevat-iot.com."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "7. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Disclaimer of Warranty and Limitation of Liability"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE SERVICE IS AT YOUR OWN RISK. THE SERVICE IS PROVIDED "AS IS", WITHOUT WARRANTIES OF ANY KIND. ELEVAT, TO THE FULLEST EXTENT ALLOWED BY THE LAW, EXPRESSLY DISCLAIMS ANY / ALL WARRANTIES, EITHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE. ELEVAT SHALL HAVE ABSOLUTELY NO LIABILITY IN CONNECTION WITH THE SERVICE INCLUDING WITHOUT LIMITATION, ANY LIABILITY FOR DAMAGE TO YOUR COMPUTER HARDWARE, SOFTWARE, LOSS OF DATA, LOSS OF BUSINESS, INABILITY TO ACCESS DATA OR THE SERVICE, OR THE LACK OF INFORMATION IN ANY WAY RELATING TO THE SERVICE. WHILE WE ATTEMPT TO ENSURE THAT YOUR ACCESS TO AND USE OF THE SERVICE IS SAFE, RELIABLE, AND ERROR-FREE, ELEVAT CANNOT GUARANTEE, AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, OR ANY ELEMENT THEREOF, INCLUDING SOFTWARE OR SYSTEMS ARE AVAILABLE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "IN NO EVENT WILL ELEVAT\u2019S TOTAL LIABILITY TO YOU FOR ALL DAMAGES ARISING FOR YOUR USE OF THE SERVICE OR INFORMATION, MATERIALS, OR PRODUCTS MADE AVAILABLE TO YOU THROUGH THE SERVICE EXCEED THE GREATER OF $100 OR THE AMOUNT YOU PAID TO ELEVAT FOR THE AFFECTED MATERIALS. IN NO EVENT WILL ELEVAT BE LIABLE FOR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES, PERSONAL INJURY/WRONGFUL DEATH, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION RESULTING FROM THE ACCESS TO, USE OF, OR RELIANCE ON, THE SERVICE, APPS OR IN-APP PRODUCTS WHETHER BASED ON WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL THEORY, WHETHER OR NOT ELEVAT IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THESE LIMITATIONS WILL APPLY TO YOU EVEN IF THE REMEDIES FAIL OF THEIR ESSENTIAL PURPOSE."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "8. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Indemnity"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You agree to defend, indemnify and hold Elevat, its officers, directors, employees, agents, licensors and business partners, harmless from and against any claims, actions or demands, liabilities and settlements including without limitation, reasonable legal and accounting fees, resulting from, or alleged to result from, your violation of these Terms."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "9. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Geographic Restrictions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Elevat is based in the United States of America. Elevat makes no claims that the Service is appropriate or may be used outside of the United States. Access to and use of the Service is intended solely for persons residing in the United States and may not be legal by certain persons or in certain countries. If you use the Service from outside the United States, you do so at your own risk and are responsible for compliance with the laws of your jurisdiction."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "10. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Jurisdiction and Venue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "These Terms are governed by and construed in accordance with the laws of the State of Washington, without regard to its conflict of law principles. You expressly agree that exclusive jurisdiction for any dispute with Elevat, or in any way relating to the Service, resides in the state and federal courts in Seattle, Washington, and you hereby expressly, irrevocably, and unconditionally consent and submit to the exercise of personal jurisdiction by such courts."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "11. "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "General"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "If any part of the Terms is determined to be invalid or unenforceable pursuant to applicable law, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the Terms will continue in effect. You may not assign these Terms, or assign, transfer or sublicense your rights, if any, in the Service, however, Elevat may freely assign these Terms. Unless expressly stated in another written agreement between you and us, the Terms constitute the entire agreement between you and us with respect to the Service. You agree and consent to receive communications from us via each of the following methods: by posting or making available such communication within the Service or by sending such communication to the email address you provided as part of your account. You agree that all agreements, notices, disclosures and other communications that we may provide to you electronically satisfy any legal requirement that such communications be in writing."
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4v17f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resetPasswordDisplay = require("./ResetPasswordDisplay");
var _resetPasswordDisplayDefault = parcelHelpers.interopDefault(_resetPasswordDisplay);
var _accountService = require("../../Services/AccountService");
var _accountServiceDefault = parcelHelpers.interopDefault(_accountService);
exports.default = /*#__PURE__*/ (0, _react.memo)(ResetPasswordModalContainer);
const initState = {
    email: "",
    resetRequestPending: false
};
const account = new (0, _accountServiceDefault.default)();
function ResetPasswordModalContainer(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const { toggleModal, showResetPasswordAlert } = props;
    const handleSubmit = async ()=>{
        updateState({
            ...state,
            resetRequestPending: true
        });
        const { email } = state;
        try {
            const { message } = await account.forgotPassword({
                email
            });
            toggleModal();
            showResetPasswordAlert("alert-confirmation", "text-white", message);
        } catch (err) {
            toggleModal();
            showResetPasswordAlert("danger", "text-white", "An error occurred, please try again later");
        }
    };
    const handlePropUpdate = ({ target: { name, value } = {} })=>{
        updateState({
            ...state,
            [name]: value
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordDisplayDefault.default), {
        ...props,
        ...state,
        handleSubmit: handleSubmit,
        handlePropUpdate: handlePropUpdate
    });
}
ResetPasswordModalContainer.propTypes = {
    toggleModal: (0, _propTypesDefault.default).func,
    showResetPasswordAlert: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","./ResetPasswordDisplay":"1pINI","../../Services/AccountService":"3PgTR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pINI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResetPasswordModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function ResetPasswordModalDisplay(props) {
    const { handlePropUpdate, handleSubmit, toggleModal, isOpen, email, resetRequestPending } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: isOpen,
        desktopHeight: "50vh",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 px-md-4 pt-md-4 d-flex",
                toggle: toggleModal,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-3059975369 d-flex px-md-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            className: "jsx-3059975369 modal-title-text",
                            children: "Forgot Password?"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-3059975369 text-text-light-gray nine-tenth-text d-flex px-md-2",
                        children: "Reset your password by inputting your email below. If the email exists, the system will generate a new random password and email it to the user."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                className: "pt-3 px-md-4 text-text-light-gray",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3059975369 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "email",
                            className: "jsx-3059975369 modal-inputlabel-text",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "email",
                            onChange: handlePropUpdate,
                            placeholder: "Enter email",
                            type: "text",
                            value: email,
                            className: "jsx-3059975369 form-control modal-placeholder-text"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-top-0 px-md-4 pt-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: handleSubmit,
                    className: "jsx-3059975369 btn modal-button-submit px-4 py-1 m-0",
                    children: resetRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                        spin: true
                    }) : "Reset Password"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3059975369",
                children: ".modal-title{width:100%;}"
            })
        ]
    });
}
ResetPasswordModalDisplay.propTypes = {
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleSubmit: (0, _propTypesDefault.default).func,
    toggleModal: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    email: (0, _propTypesDefault.default).string,
    resetRequestPending: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","../ModalLayout":"2RoDj","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jB843":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MFADisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _centerContainer = require("../CenterContainer");
var _centerContainerDefault = parcelHelpers.interopDefault(_centerContainer);
var _trackerClasses = require("../../Constants/TrackerClasses");
var _termsAndConditionsTemplate = require("./TermsAndConditionsTemplate");
var _termsAndConditionsTemplateDefault = parcelHelpers.interopDefault(_termsAndConditionsTemplate);
const { className: inputClass, styles: inputStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1193078894",
        children: "input.jsx-1193078894{border-radius:15px;}input.jsx-1193078894::-webkit-input-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894::-moz-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894:-ms-input-placeholder{color:var(--icon-link-gray);}input.jsx-1193078894::placeholder{color:var(--icon-link-gray);}.form-control.jsx-1193078894:focus{outline:none;}input.jsx-1193078894::-webkit-credentials-auto-fill-button{visibility:hidden;display:none !important;pointer-events:none;position:absolute;right:0;}input.jsx-1193078894:-webkit-autofill{-webkit-box-shadow:0 0 0px 1000px white inset;}"
    }),
    className: "jsx-1193078894"
};
const { className: alertClass, styles: alertStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3252027598",
        children: ".alert.jsx-3252027598{background:var(--brand-primary-alert);opacity:0.7;right:12.5%;top:5rem;z-index:10000;}.alert-hidden.jsx-3252027598{opacity:0;-webkit-transition:all 250ms linear;transition:all 250ms linear;}"
    }),
    className: "jsx-3252027598"
};
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "4264976005",
        children: "@media (max-width:767px){.modal-dialog.jsx-4264976005{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}.modal-body.jsx-4264976005{max-height:calc(100vh - 123px);overflow-y:auto;}}@media (min-width:768px){.modal-body.jsx-4264976005{max-height:60vh;overflow-y:auto;}}"
    }),
    className: "jsx-4264976005"
};
const AlertDisplay = ({ showAlert, toggleAlert, alertMessage })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Alert), {
                toggle: toggleAlert,
                className: `${alertClass} position-fixed w-75 border-0 ${showAlert ? null : "alert-hidden"}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-527641253 " + `d-flex align-items-center justify-content-center text-white alert-font-size`,
                    children: alertMessage
                })
            }),
            alertStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "527641253",
                children: ".alert-font-size.jsx-527641253{font-size:1rem;}"
            })
        ]
    });
};
AlertDisplay.propTypes = {
    showAlert: (0, _propTypesDefault.default).bool,
    toggleAlert: (0, _propTypesDefault.default).func,
    fadeOut: (0, _propTypesDefault.default).string,
    alertMessage: (0, _propTypesDefault.default).string
};
const HeaderDisplay = ()=>{
    const { isElevatUi, isSupraUi, isVersatileUi, logo_url, tige_login_logo_url } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const { certificateIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const isTigeDemoUi = window.location.host?.includes("tige");
    const hideConnectingText = isVersatileUi || isSupraUi || isTigeDemoUi;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-1586202726 " + `text-center mt-${hideConnectingText ? "4" : "2"}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                        className: isElevatUi ? "" : isSupraUi ? "mb-5" : "mb-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            alt: "brand",
                            src: isTigeDemoUi ? tige_login_logo_url : logo_url,
                            className: "jsx-1586202726 login-logo image-fluid mw-100 mx-auto"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-1586202726 " + ((hideConnectingText ? "d-none" : "text-center text-elevat-blue three-quarter-text mx-auto mb-4") || ""),
                        children: "Connecting the Industrial World"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1586202726 two-factor-container text-center text-text-gray mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-1586202726",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    alt: "two-factor-icon",
                                    src: certificateIcon,
                                    className: "jsx-1586202726 login-two-factor-icon"
                                })
                            }),
                            "Two Factor Authentication"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1586202726",
                children: ".two-factor-container.jsx-1586202726{margin-top:40px;font-size:0.8rem;white-space:nowrap;}.login-two-factor-icon.jsx-1586202726{max-height:20px;margin-right:5px;margin-bottom:5px;}.login-logo.jsx-1586202726{max-height:70px;}.elevat-text.jsx-1586202726{font-size:1.2rem;margin-left:2px;}@media (min-width:768px){.login-logo.jsx-1586202726{max-height:100px;}}"
            })
        ]
    });
};
const FormDisplay = ({ handleTwoFactor, challenge, handlePropUpdate, showError, twoFactorError, handleSubmit, loginRequestPending })=>{
    const { isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Form), {
                onSubmit: handleTwoFactor,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                        row: true,
                        style: {
                            marginTop: "40px",
                            marginBottom: "0px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                style: {
                                    marginBottom: "5px"
                                },
                                className: "text-center text-text-light-gray",
                                for: "login-two-factor",
                                children: "Authentication Code"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2884368294",
                                        [
                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                        ]
                                    ]
                                ]) + " " + "input-group",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                    className: `bg-white shadow-none ${inputClass} border-${showError ? "danger" : isVersatileUi ? "input-border-gray" : isSupraUi ? "dark" : "elevat-blue"}`,
                                    type: "text",
                                    id: "challenge",
                                    name: "challenge",
                                    placeholder: "123456",
                                    value: challenge,
                                    onChange: handlePropUpdate,
                                    invalid: showError,
                                    autoComplete: "one-time-code",
                                    // eslint-disable-next-line jsx-a11y/no-autofocus
                                    autoFocus: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    marginTop: "10px"
                                },
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2884368294",
                                        [
                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                        ]
                                    ]
                                ]) + " " + "text-text-light-gray three-quarter-text",
                                children: "We'll remember you for 24 hours"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2884368294",
                                [
                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "error-container row align-items-center",
                        children: showError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                marginLeft: "0px",
                                paddingBottom: "20px"
                            },
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2884368294",
                                    [
                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                    ]
                                ]
                            ]) + " " + `text-danger error-text ${0, _trackerClasses.ERROR_LOGIN_FORM}`,
                            children: twoFactorError
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2884368294",
                                [
                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "resend-code-container row text-text-light-gray text-decoration-none shadow-none",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2884368294",
                                    [
                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                    ]
                                ]
                            ]),
                            children: [
                                "We just sent a verification code to your phone number. Didn't get it?",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: handleSubmit,
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "2884368294",
                                            [
                                                isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                            ]
                                        ]
                                    ]) + " " + "btn btn-link mx-auto resend-code-link text-decoration-none shadow-none p-0",
                                    children: "Resend the code."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            disabled: loginRequestPending,
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2884368294",
                                    [
                                        isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                    ]
                                ]
                            ]) + " " + `btn mt-auto login-button${isVersatileUi ? "-versatile" : ""} flex-grow-1 form-border-radius d-flex align-items-center justify-content-center`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2884368294",
                                        [
                                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                        ]
                                    ]
                                ]) + " " + `login-button-text${isVersatileUi ? "-versatile" : ""}`,
                                children: loginRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                    spin: true,
                                    size: "lg"
                                }) : "Verify"
                            })
                        })
                    })
                ]
            }),
            inputStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2884368294",
                dynamic: [
                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                ],
                children: `.login-button.__jsx-style-dynamic-selector{height:35px;background-color:var(--login-button-background-color);cursor:pointer;}.login-button.__jsx-style-dynamic-selector:focus,.login-button.__jsx-style-dynamic-selector:hover{background-color:var(--login-button-hover-background-color);outline:none;}.login-button-versatile.__jsx-style-dynamic-selector{background-color:var(--white);border-color:var(--brand-primary);color:var(--brand-primary);cursor:pointer;height:35px;}.login-button-versatile.__jsx-style-dynamic-selector:focus,.login-button-versatile.__jsx-style-dynamic-selector:hover{background-color:var(--brand-primary);color:var(--white);}.login-button-text.__jsx-style-dynamic-selector{color:var(--white);font-size:1.2rem;}.login-button-text-versatile.__jsx-style-dynamic-selector{color:inherit;font-size:1.2rem;}.login-button-text-versatile.__jsx-style-dynamic-selector:focus,.login-button-text-versatile.__jsx-style-dynamic-selector:hover{color:var(--white);}.resend-code-container.__jsx-style-dynamic-selector{font-size:0.8rem !important;color:var(--black-text);margin-bottom:30px;}.resend-code-link.__jsx-style-dynamic-selector{color:var(--brand-primary);cursor:pointer;font-size:0.8rem !important;}.resend-code-link.__jsx-style-dynamic-selector:hover{color:var( --${isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"} ) !important;}.form-border-radius.__jsx-style-dynamic-selector{border-radius:15px;}.error-container.__jsx-style-dynamic-selector{height:20px;}.error-text.__jsx-style-dynamic-selector{margin-left:10px;font-size:0.81rem;}`
            })
        ]
    });
};
FormDisplay.propTypes = {
    handleSubmit: (0, _propTypesDefault.default).func,
    handleTwoFactor: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    challenge: (0, _propTypesDefault.default).string,
    showError: (0, _propTypesDefault.default).bool,
    twoFactorError: (0, _propTypesDefault.default).string,
    loginRequestPending: (0, _propTypesDefault.default).bool
};
const FooterDisplay = ({ toggleTermsAndConditionsModal, termsModal })=>{
    const { contact_url, isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "3355800279",
                        [
                            isVersatileUi ? "elevat-blue" : "black-text",
                            isSupraUi ? "brand-primary" : "highlight-blue",
                            isVersatileUi ? "text-white" : "elevat-blue"
                        ]
                    ]
                ]) + " " + "login-form-footer d-flex flex-column justify-content-center align-items-center flex-md-row justify-content-md-between align-items-md-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "3355800279",
                                [
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue",
                                    isVersatileUi ? "text-white" : "elevat-blue"
                                ]
                            ]
                        ]) + " " + "text-nowrap pl-lg-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "3355800279",
                                    [
                                        isVersatileUi ? "elevat-blue" : "black-text",
                                        isSupraUi ? "brand-primary" : "highlight-blue",
                                        isVersatileUi ? "text-white" : "elevat-blue"
                                    ]
                                ]
                            ]),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "3355800279",
                                            [
                                                isVersatileUi ? "elevat-blue" : "black-text",
                                                isSupraUi ? "brand-primary" : "highlight-blue",
                                                isVersatileUi ? "text-white" : "elevat-blue"
                                            ]
                                        ]
                                    ]) + " " + "branded-text",
                                    children: "powered by "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "3355800279",
                                            [
                                                isVersatileUi ? "elevat-blue" : "black-text",
                                                isSupraUi ? "brand-primary" : "highlight-blue",
                                                isVersatileUi ? "text-white" : "elevat-blue"
                                            ]
                                        ]
                                    ]) + " " + "branded-text font-weight-light",
                                    children: "elev\u0101t"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "3355800279",
                                [
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue",
                                    isVersatileUi ? "text-white" : "elevat-blue"
                                ]
                            ]
                        ]) + " " + "text-nowrap",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "3355800279",
                                        [
                                            isVersatileUi ? "elevat-blue" : "black-text",
                                            isSupraUi ? "brand-primary" : "highlight-blue",
                                            isVersatileUi ? "text-white" : "elevat-blue"
                                        ]
                                    ]
                                ]) + " " + "branded-text",
                                children: "Don't have an account?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: contact_url,
                                rel: "noopener noreferrer",
                                target: "_blank",
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "3355800279",
                                        [
                                            isVersatileUi ? "elevat-blue" : "black-text",
                                            isSupraUi ? "brand-primary" : "highlight-blue",
                                            isVersatileUi ? "text-white" : "elevat-blue"
                                        ]
                                    ]
                                ]) + " " + "login-form-link ml-2",
                                children: "Contact Us"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "3355800279",
                                [
                                    isVersatileUi ? "elevat-blue" : "black-text",
                                    isSupraUi ? "brand-primary" : "highlight-blue",
                                    isVersatileUi ? "text-white" : "elevat-blue"
                                ]
                            ]
                        ]) + " " + "text-nowrap pr-lg-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: toggleTermsAndConditionsModal,
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "3355800279",
                                    [
                                        isVersatileUi ? "elevat-blue" : "black-text",
                                        isSupraUi ? "brand-primary" : "highlight-blue",
                                        isVersatileUi ? "text-white" : "elevat-blue"
                                    ]
                                ]
                            ]) + " " + "btn m-0 p-0 login-form-link",
                            children: "Terms and Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
                        className: modalClass,
                        isOpen: termsModal,
                        toggle: toggleTermsAndConditionsModal,
                        style: {
                            maxWidth: "620px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                                className: "border-0",
                                toggle: toggleTermsAndConditionsModal,
                                children: "Terms of Service"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                                className: `${modalClass} text-left`,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsAndConditionsTemplateDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: toggleTermsAndConditionsModal,
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "3355800279",
                                            [
                                                isVersatileUi ? "elevat-blue" : "black-text",
                                                isSupraUi ? "brand-primary" : "highlight-blue",
                                                isVersatileUi ? "text-white" : "elevat-blue"
                                            ]
                                        ]
                                    ]) + " " + "btn btn-outline-secondary py-0 px-3 mr-3",
                                    children: "Close"
                                })
                            })
                        ]
                    })
                ]
            }),
            modalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3355800279",
                dynamic: [
                    isVersatileUi ? "elevat-blue" : "black-text",
                    isSupraUi ? "brand-primary" : "highlight-blue",
                    isVersatileUi ? "text-white" : "elevat-blue"
                ],
                children: `.login-form-footer.__jsx-style-dynamic-selector{font-size:0.8rem;line-height:1.2rem;}.login-form-link.__jsx-style-dynamic-selector{font-size:0.8rem !important;-webkit-text-decoration:none;text-decoration:none;color:var(--${isVersatileUi ? "elevat-blue" : "black-text"});cursor:pointer;box-shadow:none;}.login-form-link.__jsx-style-dynamic-selector:focus,.login-form-link.__jsx-style-dynamic-selector:hover{-webkit-text-decoration:none;text-decoration:none;color:var( --${isSupraUi ? "brand-primary" : "highlight-blue"} ) !important;}.login-form-link.__jsx-style-dynamic-selector:active,.login-form-link.__jsx-style-dynamic-selector:visited,.login-form-link.__jsx-style-dynamic-selector:focus{-webkit-text-decoration:none;text-decoration:none;}.branded-text.__jsx-style-dynamic-selector{color:var(--${isVersatileUi ? "text-white" : "elevat-blue"});}@media (max-width:768px){.login-form-footer.__jsx-style-dynamic-selector{max-height:50px;}}@media (min-width:768px){.login-form-footer.__jsx-style-dynamic-selector{margin-top:60px;}}`
            })
        ]
    });
};
FooterDisplay.propTypes = {
    toggleTermsAndConditionsModal: (0, _propTypesDefault.default).func,
    termsModal: (0, _propTypesDefault.default).bool
};
function MFADisplay(props) {
    const { alertMessage, challenge, handlePropUpdate, handleSubmit, handleTwoFactor, loginRequestPending, showAlert, showError, termsModal, toggleAlert, toggleTermsAndConditionsModal, twoFactorError } = props;
    const { isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _centerContainerDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Container), {
                fluid: true,
                className: "p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertDisplay, {
                            showAlert: showAlert,
                            toggleAlert: toggleAlert,
                            alertMessage: alertMessage
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "1014851328",
                                    [
                                        isVersatileUi ? "500" : "550",
                                        isVersatileUi ? "550" : "600"
                                    ]
                                ]
                            ]) + " " + "col align-self-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "1014851328",
                                            [
                                                isVersatileUi ? "500" : "550",
                                                isVersatileUi ? "550" : "600"
                                            ]
                                        ]
                                    ]) + " " + "outer-container d-flex flex-column mx-auto shadow p-3 bg-white rounded",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                            xs: {
                                                size: 10,
                                                offset: 1
                                            },
                                            md: {
                                                size: 6,
                                                offset: 3
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderDisplay, {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormDisplay, {
                                                    handleSubmit: handleSubmit,
                                                    handleTwoFactor: handleTwoFactor,
                                                    handlePropUpdate: handlePropUpdate,
                                                    challenge: challenge,
                                                    twoFactorError: twoFactorError,
                                                    showError: showError,
                                                    loginRequestPending: loginRequestPending
                                                })
                                            ]
                                        }),
                                        !isVersatileUi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: (0, _styleDefault.default).dynamic([
                                                [
                                                    "1014851328",
                                                    [
                                                        isVersatileUi ? "500" : "550",
                                                        isVersatileUi ? "550" : "600"
                                                    ]
                                                ]
                                            ]) + " " + "mt-auto",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FooterDisplay, {
                                                termsModal: termsModal,
                                                toggleTermsAndConditionsModal: toggleTermsAndConditionsModal
                                            })
                                        }) : null
                                    ]
                                }),
                                isVersatileUi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        maxWidth: "620px"
                                    },
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "1014851328",
                                            [
                                                isVersatileUi ? "500" : "550",
                                                isVersatileUi ? "550" : "600"
                                            ]
                                        ]
                                    ]) + " " + "mx-auto mt-2 text-white",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FooterDisplay, {
                                        termsModal: termsModal,
                                        toggleTermsAndConditionsModal: toggleTermsAndConditionsModal
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1014851328",
                dynamic: [
                    isVersatileUi ? "500" : "550",
                    isVersatileUi ? "550" : "600"
                ],
                children: `.outer-container.__jsx-style-dynamic-selector{height:${isVersatileUi ? "500" : "550"}px;max-width:620px;color:var(--black-text);}@media (min-width:768px){.outer-container.__jsx-style-dynamic-selector{height:${isVersatileUi ? "550" : "600"}px;}}`
            })
        ]
    });
}
MFADisplay.propTypes = {
    alertMessage: (0, _propTypesDefault.default).string,
    challenge: (0, _propTypesDefault.default).string,
    handleSubmit: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleTwoFactor: (0, _propTypesDefault.default).func,
    loginRequestPending: (0, _propTypesDefault.default).bool,
    showAlert: (0, _propTypesDefault.default).bool,
    showError: (0, _propTypesDefault.default).bool,
    termsModal: (0, _propTypesDefault.default).bool,
    toggleAlert: (0, _propTypesDefault.default).func,
    toggleTermsAndConditionsModal: (0, _propTypesDefault.default).func,
    twoFactorError: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/BrandingContext":"bKKTd","../../Context/IconsContext":"lzIpe","../CenterContainer":"c36BU","../../Constants/TrackerClasses":"1AdWb","./TermsAndConditionsTemplate":"5bH2W","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},[], null, "parcelRequire287b")

//# sourceMappingURL=Login.2cadbac0.js.map
